import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../Icon/Icon';

const FieldError = ({ children, showErrorIcon, ...rest }) => <small aria-live="polite" className="c-form__error" {...rest}>
    {showErrorIcon && (
      <Icon icon="alert" type="error" className="c-form__error-icon" />
    )}
    {children}
  </small>

export default FieldError;

FieldError.propTypes = {
  children: PropTypes.node,
  showErrorIcon: PropTypes.bool,
};
FieldError.defaultProps = {
  children: null,
  showErrorIcon: false,
};
